import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getDetalleComprobanteCtaCte } from "../../../actions/turnos/ctaCte";
import { TIPO_COMPROBANTE } from "../../../utils/constants";

import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";
import PracticasHandler from "../recepcionDiaria/PracticasHandler";
import ConsultaPracticas from "../recepcionDiaria/ConsultaPracticas";
import { MonetizationOn } from "@material-ui/icons";
import { validarSoloUnPermiso } from "../../../helpers/permisos";
import { TURNOS_PERMISOS } from "../../../utils/permisos";

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const ListaCtaCte = (props) => {
  const dispatch = useDispatch();

  const { permisos: permisosUser } =  useSelector(state => state.auth);

  const [openModalPracticas, setOpenModalPracticas] = useState(false);
  const [openPracticasHandler, setOpenPracticasHandler] = useState(false);
  const [usuarioTurnoSeleccionado, setUsuarioTurnoSeleccionado] = useState(null);
  const [idAgenda, setIdAgenda] = useState(0);
  const [fecha, setFecha] = useState(0);

  const { idAfiliado, idObraSocial, nroDocumento, turnos, page, rowsPerPage, total, dense } = props;

  const onClickRowHandler = (e, turno) => {
    const onClickName = e.target.textContent;

    if (onClickName !== "Pagar") {
      const data = {
        idAfiliado,
        idObraSocial,
        nroDocumento,
        idTipoComprobante2: turno.idTipoComprobante2,
        nroComprobante2: turno.nroComprobante2,
        fechaComprobante2: turno.fechaComprobante2,
        nroComprobante: turno.nroComprobante,
      };

      dispatch(
        getDetalleComprobanteCtaCte(data, props.setDisplayDetalleComprobante)
      );
    }
  };

  const onClickPagarHandler = (turno) => {
    props.setTurnoSelec(turno);
    props.setPagoACuenta(false);
    props.setDisplayModalPagoTurno(true);
  };

  const onClickPagoCuentaHandler = (turno) => {
    props.setTurnoSelec(turno);
    props.setPagoACuenta(true);
    props.setDisplayModalPagoTurno(true);
  };

  const closeModalPracticasHandler = () => {
    setOpenModalPracticas(false);
    setOpenPracticasHandler(false);
    setUsuarioTurnoSeleccionado(null);
  };

  const onClickShowMenuPracticasHandler = (item) => {
    setIdAgenda(item.idAgenda);
    setFecha(item.fechaComprobante2);
    setOpenModalPracticas(true);
  };

  return (
    <React.Fragment>
      {openModalPracticas && (
        <ConsultaPracticas
          open={openModalPracticas}
          onClose={closeModalPracticasHandler}
          idAgenda={idAgenda}
          fecha={fecha}
        />
      )}
      <Table size={dense ? "small" : "medium"}>
        <TableHead>
          <TableRow>
            <TableCell align="left">Fecha</TableCell>
            <TableCell align="left">Afiliado</TableCell>
            <TableCell align="left">Nro Comprobante</TableCell>
            <TableCell align="left">Tipo</TableCell>
            <TableCell align="left">Exento</TableCell>
            <TableCell align="left">Centro Médico</TableCell>
            <TableCell align="left">Profesional</TableCell>
            <TableCell align="left">Especialidad</TableCell>
            {/* <TableCell align="left">Hora</TableCell> */}
            <TableCell align="left">Importe</TableCell>
            <TableCell align="left">Saldo</TableCell>
            <TableCell align="left" style={{ width: "7%" }}>
              <Tooltip 
                title={
                  <>
                    <span style={{fontSize: 14}}>
                      {`Pago a Cuenta`}
                    </span>
                  </>
                }
              >
                <IconButton
                  style={{float: 'right', padding: 10, marginTop: 0}}
                  color="inherit" 
                  disabled={
                    !validarSoloUnPermiso(
                      permisosUser, 
                      TURNOS_PERMISOS.PAGO_ADELANTADO_TURNO
                    )
                  }
                  onClick={() => onClickPagoCuentaHandler()}
                >
                  <MonetizationOn />
                </IconButton>
              </Tooltip>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {turnos?.length > 0 ? (
            <React.Fragment>
              {turnos
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((turno, index) => (
                  <TableRow
                    key={index}
                    onClick={(e) => onClickRowHandler(e, turno)}
                  >
                    <TableCell align="left">
                      {new Date(turno.fechaComprobante2).toLocaleString(
                        "es",
                        optionsfecha
                      )}
                    </TableCell>
                    <TableCell align="left">{turno.afiliado}</TableCell>
                    <TableCell align="left">{turno.nroComprobante2}</TableCell>
                    <TableCell align="left">
                      {turno.descripcionTipoComprobante}
                    </TableCell>
                    <TableCell align="left">
                      {turno.exento ? "Si" : "No"}
                    </TableCell>
                    <TableCell align="left">{turno.centroMedico}</TableCell>
                    <TableCell align="left">
                      {turno.nombreProfesional}
                    </TableCell>
                    <TableCell align="left">{turno.especialidad}</TableCell>
                    {/* <TableCell align="left">{turno.hora}</TableCell> */}
                    <TableCell align="left">
                      {turno.importe < 0
                        ? `-$${Math.abs(turno.importe).toFixed(2)}`
                        : `\u00A0$${turno.importe.toFixed(2)}`}
                    </TableCell>
                    <TableCell
                      align="left"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography style={{ fontSize: "0.875rem" }}>
                          {turno.saldo < 0
                            ? `-$${Math.abs(turno.saldo).toFixed(2)}`
                            : `\u00A0$${turno.saldo.toFixed(2)}`}
                        </Typography>
                        {turno.descripcionTipoComprobante === "Factura" && (
                          <PracticasHandler
                            item={turno}
                            mostrarButtonConsulta={true}
                            mostrarButtonAdd={false}
                            openPracticasHandler={openPracticasHandler}
                            onClickAdd={onClickShowMenuPracticasHandler}
                            setOpenPracticasHandler={setOpenPracticasHandler}
                            onClickConsultar={onClickShowMenuPracticasHandler}
                            usuarioTurnoSeleccionado={usuarioTurnoSeleccionado}
                            setUsuarioTurnoSeleccionado={setUsuarioTurnoSeleccionado}
                          />
                        )}
                      </div>
                    </TableCell>
                    <TableCell align="left">
                      {turno.idTipoComprobante === TIPO_COMPROBANTE.FACTURA &&
                        turno.saldo > 0 && (
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={() => onClickPagarHandler(turno)}
                          >
                            Pagar
                          </Button>
                        )}
                    </TableCell>
                  </TableRow>
                ))}
              <TableRow
                style={{ border: "solid gray", borderWidth: "1.1px 0" }}
              >
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell
                  style={{
                    fontWeight: "bold",
                    minWidth: "8.625rem",
                  }}
                >
                  TOTAL{" "}
                  {total < 0
                    ? `-$${Math.abs(total).toFixed(2)}`
                    : `\u00A0$${total.toFixed(2)}`}
                </TableCell>
              </TableRow>
            </React.Fragment>
          ) : (
            <TableRow style={{ height: 50 }}>
              <TableCell colSpan={12} style={{ textAlign: "-webkit-center" }}>
                {" "}
                Sin Registros
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </React.Fragment>
  );
};
